import { TransactionDelegate, TransactionStatus } from '@/features/Transactions/transactions.types'
import { getSign } from '@/shared/helpers/crypto'
import React from 'react'
import { TransactionRow } from '../Common/TransactionRow'

export function ChangeBalance({ transaction, onClick, withoutDate }: {
  onClick: () => void;
  transaction: TransactionDelegate;
  withoutDate: boolean;
}) {
  return (
    <TransactionRow
      amount={transaction.data.cryptoAmount}
      createdAt={transaction.createdAt}
      iconType={getSign(transaction.data.cryptoAmount) === '+' ? 'CHANGE_BALANCE_UP' : 'CHANGE_BALANCE_DOWN'}
      isError={transaction.status === TransactionStatus.ERROR_SEND}
      onClick={onClick}
      status={transaction.status}
      title="Transfer"
      type={transaction.data.type}
      withoutDate={withoutDate}
    />
  )
}
